import type { HeaderMenuProps } from './HeaderMenu';
import type { ReactNode } from 'react';
import { Container, Row, Col, IconButton } from '@workramp/ui';
import isFeatureEnabled from '~/components/common/is-feature-enabled';
import { LearnerSearchBar } from '~/elc/features/learner-search/components/LearnerSearchBar';
import { SIDEBAR_WIDTH } from '../../constants';
import { HeaderMenu } from './HeaderMenu';
import { HeaderSearchBar } from './HeaderSearchBar';
import { HeaderWrapper } from './Header.styles';

const { I18n } = window;

export interface HeaderProps extends HeaderMenuProps {
  isWhiteLabel?: boolean;
  showMenuButton?: boolean;
  onOpenMenu: () => void;
  searchBar?: ReactNode;
}

export function Header({ isWhiteLabel, showMenuButton, onOpenMenu, searchBar, ...props }: HeaderProps) {
  const TRANSLATED_MENU_LABEL = I18n.t('js.learner.home.sidebar.open_sidebar_label');

  const getSearchBar = () => {
    if (searchBar) {
      return searchBar;
    }
    if (isFeatureEnabled('fy25_q1_learner_search')) {
      return <LearnerSearchBar />;
    }
    return <HeaderSearchBar />;
  };

  return (
    <HeaderWrapper>
      <Container isFluid compression={showMenuButton ? 0 : SIDEBAR_WIDTH}>
        <Row justify="space-between" align="center">
          {!isWhiteLabel && showMenuButton && (
            <Col xs="auto">
              <IconButton
                label={TRANSLATED_MENU_LABEL}
                iconName="burger:regular"
                variant="text"
                color="secondary"
                size="lg"
                onPress={onOpenMenu}
              />
            </Col>
          )}

          <Col xs="fill" lg={6}>
            {getSearchBar()}
          </Col>

          <Col xs="auto">
            <HeaderMenu isWhiteLabel={isWhiteLabel} {...props} />
          </Col>
        </Row>
      </Container>
    </HeaderWrapper>
  );
}
